import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { Observable } from 'rxjs';
import { RecurrentPaymentListDto } from '../models/recurring-payment.models';
import { UserInfoService } from '../../../services/user-info.service';
import { SortTableService } from '../../../services/sort-table.service';
import { FilterSearchResultDto } from 'src/app/models/filter.model';

@Injectable({
  providedIn: 'root',
})
export class RecurringPaymentDataService {
  agentId: string | undefined;
  userId: number | undefined;

  sort: string | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService,
    private sortTableService: SortTableService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });

    this.sortTableService.sortColum$.subscribe({
      next: (res) => {
        this.sort = res;
      },
    });
  }

  loadRecurringPaymentFilter(): Observable<any> {
    const url = `/agents/${this.agentId}/recurring_payments/filter`;
    return this.apiService.httpGet<any>(url);
  }

  loadRecurringPaymentList(
    page: number,
    search: string | undefined = '',
    data?: any
  ): Observable<RecurrentPaymentListDto> {
    const url = `/agents/${this.agentId}/recurring_payments/filter?page_number=${page}&per_page=20&${this.sort}&search=${search}`;
    return this.apiService.httpPost<RecurrentPaymentListDto>(url, data);
  }

  changeRecurrentPaymentStatus(id: string, status: boolean): Observable<void> {
    const url = `/agents/${this.agentId}/recurring_payment/${id}?is_blocked=${status}`;
    return this.apiService.httpPatch<void>(url);
  }

  loadSearchList(data: any): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/recurring_payments/filter/list?page_number=0&per_page=10`;
    return this.apiService.httpPost<FilterSearchResultDto>(url, data);
  }

  loadFile(): Observable<Blob> {
    const url = `/agents/${this.agentId}/reports/recurring_payments/download`;
    return this.apiService.httpGetBlob(url);
  }
}
